var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n, DataType, utils as dataUtils } from '@easydata/core';
import { DefaultDateTimePicker } from '@easydata/ui';
import { ExpressionRenderer } from './expression_renderer';
import { QPEditablePart } from '../../../types/qp_editable_part';
var DateTimeExpressionRenderer = /** @class */ (function (_super) {
    __extends(DateTimeExpressionRenderer, _super);
    function DateTimeExpressionRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dtp = null;
        _this.internalDateFormat = 'yyyy-MM-dd';
        _this.internalTimeFormat = 'HH:mm';
        return _this;
    }
    DateTimeExpressionRenderer.prototype.renderEditor = function () {
    };
    DateTimeExpressionRenderer.prototype.showEditor = function () {
        var _this = this;
        if (this.dtp)
            return;
        var pickerOptions = {
            yearRange: this.panel.options.yearRange,
            showCalendar: this.expression.dataType !== DataType.Time,
            showTimePicker: this.expression.dataType !== DataType.Date,
            oneClickDateSelection: this.panel.options.oneClickDateSelection,
            showDateTimeInput: this.panel.options.showDateTimeInput,
            onApply: function (dateTime) {
                var value = _this.convertToInternalFormat(dateTime);
                _this.setValue(value);
                _this.dtp = null;
                setTimeout(function () { return _this.labelElement.focus(); }, 100);
            },
            onCancel: function () {
                _this.labelElement.innerText = _this.getLabelText();
                _this.dtp = null;
                setTimeout(function () { return _this.labelElement.focus(); }, 100);
            },
            onDateTimeChanged: function (dateTime) {
                var value = i18n.dateTimeToStr(dateTime, _this.expression.dataType);
                _this.labelElement.innerText = value;
            }
        };
        this.dtp = this.panel.options.dateTimePickerResolver
            ? this.panel.options.dateTimePickerResolver(pickerOptions)
            : new DefaultDateTimePicker(pickerOptions);
        var model = this.expression.getModel();
        var value = this.expression.value;
        var dateTime = new Date();
        if (this.expression.dataType != DataType.Time && model.isDateMacro(value)) {
            dateTime = model.getDateMacroValue(value);
        }
        else if (this.expression.dataType == DataType.Time && model.isTimeMacro(value)) {
            dateTime = model.getTimeMacroValue(value);
        }
        else {
            dateTime = this.convertFromInternalFormat(value);
        }
        this.dtp.setDateTime(dateTime);
        this.dtp.show(this.element);
    };
    DateTimeExpressionRenderer.prototype.closeEditor = function () {
        this.dtp.cancel();
        this.dtp = null;
    };
    DateTimeExpressionRenderer.prototype.getLabelText = function () {
        if (!this.expression.value)
            return this.getEmptyText();
        var defValue = '${{Today}}';
        var value = this.expression.value;
        var model = this.expression.getModel();
        if (!model) {
            throw new Error('DataModel is not defined for ' + this.expression.value);
        }
        if (model.isDateMacro(value) || model.isTimeMacro(value)) {
            var macroText = value.substring(3, value.length - 2);
            var res = i18n.getText(macroText);
            return res ? res : defValue;
        }
        var result = i18n.dateTimeToStr(this.convertFromInternalFormat(value), this.expression.dataType);
        return result;
    };
    DateTimeExpressionRenderer.prototype.isEditable = function () {
        return _super.prototype.isEditable.call(this)
            && ((this.panel.options.editableParts & QPEditablePart.Value) === QPEditablePart.Value);
    };
    DateTimeExpressionRenderer.prototype.convertFromInternalFormat = function (dateTime) {
        return dataUtils.strToDateTime(dateTime, this.internalDateFormat + ' ' + this.internalTimeFormat);
    };
    DateTimeExpressionRenderer.prototype.convertToInternalFormat = function (dateTime) {
        return dataUtils.dateTimeToStr(dateTime, this.internalDateFormat + ' ' + this.internalTimeFormat);
    };
    return DateTimeExpressionRenderer;
}(ExpressionRenderer));
export { DateTimeExpressionRenderer };
//# sourceMappingURL=datetime_expression_render.js.map